/** HSL triplets (no `hsl()`), matching coupon-canvas-main `src/index.css` :root */
export const theme = {
  layout: {
    /** Edge-to-edge shell; horizontal rhythm from padding only */
    shellMax: "100%",
    shellPadX: "clamp(0.5rem, 1.4vw, 2rem)",
    /** Wide reading column for legal/static prose */
    proseMax: "min(100%, 96rem)",
    /** Auth and short forms */
    formMax: "min(100%, 42rem)",
  },
  font: {
    /** Root rem scale — bumps UI text on large screens */
    root: "clamp(16px, 0.45vw + 14px, 21px)",
    heroTitle: "clamp(1.875rem, 1.35rem + 2.5vw, 3.25rem)",
    sectionTitle: "clamp(1.375rem, 1.1rem + 1.1vw, 1.75rem)",
  },
  colors: {
    background: "220 20% 96%",
    foreground: "220 40% 13%",
    card: "0 0% 100%",
    cardForeground: "220 40% 13%",
    muted: "220 15% 94%",
    mutedForeground: "220 10% 46%",
    primary: "221 67% 44%",
    primaryForeground: "0 0% 100%",
    border: "220 20% 90%",
    accent: "43 80% 52%",
    accentForeground: "220 40% 13%",
    navDark: "220 40% 13%",
    navDarkForeground: "0 0% 100%",
    couponMaroon: "348 60% 35%",
    couponGold: "43 80% 52%",
    ring: "221 67% 44%",
  },
  radius: {
    sm: "calc(0.5rem - 4px)",
    md: "0.5rem",
    lg: "0.75rem",
    xl: "0.75rem",
    full: "9999px",
  },
  shadow: {
    card: "0 10px 15px -3px rgb(0 0 0 / 0.08), 0 4px 6px -4px rgb(0 0 0 / 0.08)",
    cardMd: "0 4px 6px -1px rgb(0 0 0 / 0.08), 0 2px 4px -2px rgb(0 0 0 / 0.08)",
  },
};
